import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var DataRouting = require("lib/routing/DataRouting");
var BookDisplay = require("components/reading/books/BookDisplay");
var AnswerReview = require("components/writing/answers/AnswerReview");
var AnswerEvalOverride = require("components/writing/answers/AnswerEvalOverride");
var StudentDisplay = require("components/users/students/StudentDisplay")
var Spinner = require("components/utility/Spinner");

require("writing/quizzes/quiz_review");

function propsToConditions(props) {
  var conditions = _.pick(props,"userIDs");
  conditions.perPage = props.perPage || DataRouting.PER_PAGE;
  conditions.withTotal = true;
  conditions.order="graded_at_desc"
  return conditions;
}

function sortItems(item) {
  return _.sortBy(item, (x) => new Date(x.completed_at).valueOf()).reverse();
}

function selectEvaluations(state, props) {
  if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
    return sortItems(WritingSelectors.evaluations({
      state,
      filters: { admin_score: null, subject_type: "Answer" },
    }));
  } else {
    return sortItems(WritingSelectors.evaluationsPaginated({
      state,
      page: 1,
      conditions: propsToConditions(props),
      filters: {
        "admin_score": null,
        "subject_type": "Answer", 
        "question_type": ["generic-question, text-specific-question"]
      },
    }));
  }
}

function selectAnswers(state, props, answerIDs) {
  if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
    return sortItems(WritingSelectors.answers({
      state,
      conditions: { ids: answerIDs.reverse() }
    }))
  } else {
    return sortItems(WritingSelectors.answersPaginated({
      state,
      conditions: { perPage: props.perPage || DataRouting.PER_PAGE },
      filters: { ids: answerIDs.reverse() }
    }))
  }
}

function getTotals(state, props) {
  if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
    if (state && state.evaluations) {
      return _.size(_.where(state.evaluations, { admin_score: null, subject_type: "Answer" }))
    } else {
      return 0;
    }
  } else {
    return WritingSelectors.evaluationTotal({
      state,
      conditions: propsToConditions(props),
      filters: {
        "admin_score": null,
        "subject_type": "Answer",
        "question_type": ["generic-question, text-specific-question"]
      }
    })
  }
}

@connect(
  (state, props) => {
    var evaluations = selectEvaluations(state, props)

    
    var answerIDs = [];
    answerIDs = _.pluck(evaluations, "subject_id");

    var answers = selectAnswers(state, props, answerIDs);

    return {
      evaluations: evaluations,
      answers: answers,
      loading: WritingSelectors.isLoadingAnswers({ state, key: 'index', userIDs: props.userIDs }) || 
               WritingSelectors.isLoadingEvaluations({ state, key: 'index', userIDs: props.userIDs }),
      totalCount: getTotals(state, props)
    };
  },
  (dispatch, props) => {

    function populateData() {
      // TODO: standardize FE requests
      var filters = { admin_score: null, subject_type: "Answer", question_type: ["generic-question, text-specific-question"]}

      var embeds = ["evaluation.score_details", "evaluation.analysis", "evaluation.response"]
      // handle large requests
      if ($wr.isLargeRequest(props.userIDs)) {
        var conditions = { }
        var actionFunction = WritingActions.fetchEvaluations
        var options = { embeds, filters, cache: false }
        // fetch all evaluations
        return new Promise(function (resolve, reject) {
          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, (evalPromises) => {
            resolve(evalPromises);
            
            conditions = {}
            embeds = ["answer.question", "answer.meta_data"]
            actionFunction = WritingActions.fetchAnswers
            options = { embeds }
            // fetch all answers
            $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, (answerPromises) => {
              resolve(answerPromises);
            })
          })
        }).catch(() => console.log("Evaluations and answers failed to load"))
      } else {
        dispatch(WritingActions.fetchEvaluations({
          //Add filter for subject type
          filters,
          conditions: propsToConditions(props),
          embeds,
          page: 1,
          cache: false
        })
        ).then(response => {
          var answerIDs = []
          answerIDs = _.pluck(response.evaluations, "subject_id");

          dispatch(WritingActions.fetchAnswers({
            filters: { ids: answerIDs },
            conditions: { perPage: props.perPage || DataRouting.PER_PAGE },
            embeds: ["answer.question", "answer.meta_data"],
          }))
        })
      }
    }

    function onUpdate(evaluationID, evaluationUpdate){
      if (evaluationID) {
        dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: evaluationUpdate }));
      }
    }

    return{
      populateData: populateData,
      onUpdate: onUpdate
    }
  }
)
@providePopulateData()
class EvaluationOverride extends React.Component {
  constructor(props) {
    super();

    LuckyOrangeClient.tagComponent("EvaluationOverride");
    //DisplayEdit controls the appearance of the component that appears
    //when an evaluation pops up. 
    this.state = { evaluationIndex: 0, outOfAnswers: false, displayEdit: false };
    autobind(this);
  }

  nextQuestion() {
    // TODO: standardize FE requests
    //More evals in this page    
    if (this.state.evaluationIndex < this.props.evaluations.length - 1) {
      // large requests will remove reviewed evals/answers automatically
      // so evaluation index should always be 0
      if (!$wr.isLargeRequest(this.props.userIDs)) {
        this.setState({ evaluationIndex: this.state.evaluationIndex + 1, displayEdit: false })
      } else {
        this.setState({ evaluationIndex: this.state.evaluationIndex, displayEdit: false })
      }
    }
    else{
      //No more evals on this page, and no more pages
      if (this.props.totalCount <=  this.props.answers.length){
        this.setState({ outOfAnswers: true })
      }
      //If all evals on this page have been reviewed, but more pages.
      else { 
        this.setState({ displayEdit : false, evaluationIndex: 0 })
        this.props.populateData()
      }
    }
  }

  //Override button is clicked, bringing up AnswerEvalOverride
  handleOverride = () => {
    this.setState({ displayEdit: true });
  };

  //Cancels override, closing AnswerEvalOverride
  handleCancel = () => {
    this.setState({ displayEdit: false });
  };

  formatScoreString() {
    var score = this.props.evaluations[this.state.evaluationIndex].ratio * 4;
    score = Math.floor(score * 2) / 2;
    return `This answer received a ${score} out of 4`
  }

  //Needs to be async so onUpdate() returns before populateData
  handleValidate(e) {
    $wr.nope(e);

    var originalEvaluation = this.props.evaluations[this.state.evaluationIndex];

    // Round up to the nearest 0.5
    var override = originalEvaluation.score_details.machine_score;

    var adminRatio = override / 10;

    // Project this onto the scale of the original evaluation
    var adminScore = Math.ceil(adminRatio * originalEvaluation.score_cap);

    var scoreDetails = _.extend({}, originalEvaluation.score_details, { admin_score: adminScore });

    // Included both score (for immediate display) and adminScore (for the API Patch)
    var updateData = {
      score: adminScore,
      ratio: adminRatio,
      admin_score: adminScore,
      score_details: scoreDetails,
      grader_id: originalEvaluation.score_details.grader_id,
    };

    LuckyOrangeClient.tagComponent("AdminScoreOverride");

    this.props.onUpdate(originalEvaluation.id, updateData)

    window.wrNotifications.triggerDropDownNotification({
      title: "Score Validated",
      text: "You have validated the score for this question",
      icon: "ok-sign",
    });

    this.nextQuestion()
  }

  renderControls(){
    if (this.state.displayEdit){
      return (
      <div className="overrideControls">
        <AnswerEvalOverride
          evaluation={this.props.evaluations[this.state.evaluationIndex]}
          nextQuestion={this.nextQuestion}
        />
        <button className="cancelButton buttonPrimary" onClick={this.handleCancel}>
          Cancel
        </button>
      </div>
      )
    }
    else {
      return (
        <div>
          <p className="scoreText">
            {this.formatScoreString()}
          </p>
          <div className="buttons">
            <button className="buttonPrimary firstButton" onClick={this.handleOverride}>
              Override
            </button>
            <button className="buttonSuccess spacedButton" onClick={this.handleValidate}>
              Validate
            </button>
          </div>
        </div>
      )
    }
  }

  render(){
    var display;
    //answers load in evaluations, have to check for answer array being empty
    if (this.props.loading){
      display = 
      <div className="spinnerBox">
        <Spinner/>
      </div>
    } else {
      if (this.props.answers.length>0 && this.state.outOfAnswers == false){
        display = 
          <div>
            <StudentDisplay
              studentID={this.props.answers[this.state.evaluationIndex].user_id}
              showAvatar
              avatarMaxWidth={40}
            />
            <br></br>
            <BookDisplay textID={this.props.answers[this.state.evaluationIndex].text_id} />
            <div className="date">
              {$wr.formatDateTime(this.props.answers[this.state.evaluationIndex].completed_at, "show-past-years")}
            </div>
            <br></br>
            <AnswerReview answerID={this.props.answers[this.state.evaluationIndex].id} />
            {this.renderControls()}
          </div>
        
      } else {
        display = <p>You have reviewed all answers!</p>
      }
    }
    display = (
      <div>
        <p>Optional: Edit scores and help us improve</p>
        {display}
      </div>
    );
    return <div className="quizReview">{display}</div>;
  }
}

EvaluationOverride.WrappedComponent.propTypes = StrictPropTypes({
  userIDs: PropTypes.array,
  order: PropTypes.string,
  answers: PropTypes.array,
  evaluations: PropTypes.array,
  loading: PropTypes.bool,

  onUpdate: PropTypes.func,
  populateData: PropTypes.func,
  totalCount: PropTypes.number,
});

module.exports = EvaluationOverride;


// WEBPACK FOOTER //
// ./modules/components/writing/evaluations/EvaluationOverride.js